import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getCountrySlice = createAsyncThunk(
  "country/getCountry",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/country/getCountry",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  loading: false,
  Country: [],
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountrySlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountrySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.Country = action.payload.result.list;
      })
      .addCase(getCountrySlice.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default countrySlice.reducer;
